export const mockAPIPath = {
    TRANSACTION_LIST: "./data/paymentReportsTransaction.json",
    PAYMENT_REPORT_SELLER_NAME:"./data/paymentReportSellerName.json"
};

export const serverAPIPath = {
    TRANSACTION_LIST: "/oms/sales/list",
    PAYMENT_REPORT_SELLER_NAME:"/user/sellers/name"
   
};